import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";

interface Props {
  Menuprops: menuInfo;
}

const SN_COS_BAS_REG_011 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const gridApiRefL = useRef<any>(null); // 두 번째  그리드 Reference 변수
  const searchRef = useRef<any>(null);
  const { userInfo } = global(); // Login user 정보
  //#endregion
  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_COS_BAS_REG_011";
  const defaultSize = { panel1width: "49.5%", panel2width: "49.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [columns2, setColums2] = useState<any[]>([]); // gridApiRefL 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRefH datasource 관련
  const [dataSource2, setDataSource2] = useState<any>(); // gridApiRefL datasource 관련
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  //#region grid 높이 관련
  let height1 = "49.5%";
  let height2 = "49.5%";
  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    if (menu.SN_COS_BAS_REG_011) {
      height1 = menu.SN_COS_BAS_REG_011.grid1Height
        ? menu.SN_COS_BAS_REG_011.grid1Height
        : height1;
      height2 = menu.SN_COS_BAS_REG_011.grid2Height
        ? menu.SN_COS_BAS_REG_011.grid2Height
        : height2;
    }
  }
  const [grid1Height, setGrid1Height] = useState<string | number>(height1);
  const [grid2Height, setGrid2Height] = useState<string | number>(height2);

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      setDataSource2([]);
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums1(rtn.grid.grid1); // H그리드 항목 설정
        setColums2(rtn.grid.grid2); // L그리드 항목 설정
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridApiRefH.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  const onSearch = async () => {
      const modifiedRowsH = gridApiRefH.current.getChange();
        const modifiedRowsL = gridApiRefL.current.getChange();
        if (
          modifiedRowsH.modifiedRowcount > 0 ||
          modifiedRowsL.modifiedRowcount > 0
        ) {
          const confirm = await showDialog(
            "confirm",
            "수정된 내용이 있습니다. 저장하시겠습니까?"
          );
          if (confirm) {
            await onSave();
          }
        }
        try {
          const params = {
            id: "sn_cos_bas_reg_011_01",
            params: searchRef.current.getFormdata(),
          };
    
          setDataSource1([]);
          setDataSource2([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);
          setDataSource2(data[1] || []);
    
          if (data[0] && data[0].length > 0) {
            // 1. 그리드 데이터가 바인딩되었음을 기다림
            await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)
    
            // 2. 첫 번째 행 선택 및 포커스 설정
            setGridFocus(true);
          }
    
          gridApiRefH.current.resetUpdate();
          gridApiRefL.current.resetUpdate();
        } catch (error: any) {}
  };

  const onSave = async () => {
  
  };
  //#endregion

  //#region  Event Method
  const onGrid1BtnsClick = async (id: string) => {
  
  };

    const onFocusedRowChanged = (event: any) => {
    const selectedRow = event; // 클릭한 행 데이터
    if (selectedRow) {
      // 배열로 만들어서 필터링 함수 호출
      const cd_elem = selectedRow.cd_elem;
      gridApiRefL.current.applyFilters({ cd_elem: cd_elem });
      gridApiRefL.current.selectAndFocusRow(0);
    } else {
      return;
    }
  };
  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>

      <div className="flex space-x-1.5 h-full w-full">
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1width}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
        >
          <SnGrid
             // Pros로 받은 Menuprops
            seq={1} // Grid Seqno 우클릭 메뉴용
            ref={gridApiRefH} // Grid Name
            columnConfig={columns1} // 컬럼 설정 전달
            rowData={dataSource1} // Datasource
            isEditable={true} // 수정 가능여부
            rowSelection="single" // 로우 선택 모드 (단일)
            title=" " // 그리드 타이틀 정보
            onFocusedRowChanged={onFocusedRowChanged}
            cellSelection={false}
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2width}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
        > 
          <SnGrid
             // Pros로 받은 Menuprops
            seq={2} // Grid Seqno 우클릭 메뉴용
            ref={gridApiRefL} // Grid Name
            columnConfig={columns2} // 컬럼 설정 전달
            rowData={dataSource2} // Datasource
            enableExternalChart={false} // 하단 기본 차트 생성 여부
            isEditable={true} // 수정 가능여부
            rowSelection="multiple" // 로우 선택 모드(멀티)
            title=" " // 그리드 타이틀 정보
            cellSelection={false}
          />
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});

export default SN_COS_BAS_REG_011;
